import React, { useState, useContext } from 'react';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemIcon from '@material-ui/core/ListItemIcon';

import ViewColumnIcon from '@material-ui/icons/ViewColumn';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';

import Column from '../../../../contexts/Column';

import useStyles from './styles';

const ITEM_HEIGHT = 48;

function ViewColumnMenu() {
  const { columns, setColumns } = useContext(Column);
  const classes = useStyles();

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  function handleClick(event) {
    setAnchorEl(event.currentTarget);
  }

  function handleClose() {
    setAnchorEl(null);
  }

  return (
    <>
      <IconButton
        aria-label="More"
        aria-controls="long-menu"
        aria-haspopup="true"
        onClick={handleClick}
      >
        <ViewColumnIcon />
      </IconButton>

      <Menu
        id="long-menu"
        anchorEl={anchorEl}
        keepMounted
        open={open}
        onClose={handleClose}
        PaperProps={{
          style: {
            maxHeight: ITEM_HEIGHT * 4.5,
            width: 200,
          },
        }}
      >
        {columns.map(({ field, title, hidden }, index) => (
          <MenuItem
            key={field}
            onClick={() => {
              columns[index].hidden = !hidden;
              setColumns([ ...columns ]);
              handleClose();
            }}
          >
            <ListItemText primary={title} />
            <ListItemIcon>
              {!hidden && <CheckBoxIcon className={classes.icon} />}
              {hidden && <CheckBoxOutlineBlankIcon className={classes.icon} />}
            </ListItemIcon>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}

export default ViewColumnMenu;
